import React, { useState, useRef, useEffect } from 'react';
import "../.csscode/PopUpModal.css";

export default function PopupInputFieldforObservationView({ name, label = '', value, onChange }) {
    const [open, setOpen] = useState(false);
    const [popupValue, setPopupValue] = useState('');
    const [error, setError] = useState(false);
    const textAreaRef = useRef(null);

    useEffect(() => {
        if (open && textAreaRef.current) {
            textAreaRef.current.focus();
            const length = textAreaRef.current.value.length;
            textAreaRef.current.setSelectionRange(length, length);
        }
    }, [open]);


    const handleInputClick = () => {
        setPopupValue(value || '');
        setError(false);
        setOpen(true);
    };

    const handlePopupSubmit = () => {
        if (popupValue.trim() === '') {
            setError(true);
            textAreaRef.current.focus();
            return;
        }

        setError(false);
        onChange({ target: { name, value: popupValue } });
        setOpen(false);
    };

    return (
        <>
            <input
                type="text"
                name={name}
                value={value}
                readOnly
                onClick={handleInputClick}
                onFocus={handleInputClick}
                placeholder={label}
            />

            {open && (
                <div className="inputpopup-popup">
                    <div className="inputpopup-popup-content">
                        <h4>Enter {name}</h4>
                        <textarea
                            ref={textAreaRef}
                            value={popupValue}
                            onChange={(e) => setPopupValue(e.target.value)}
                            rows={5}
                            placeholder="Enter your text here..."
                            // onDoubleClick={async () => {
                            //     try {
                            //         const text = await navigator.clipboard.readText();
                            //         setPopupValue(text);
                            //     } catch (err) {
                            //         console.error("Failed to paste from clipboard:", err);
                            //     }
                            // }}
                            style={{
                                width: '100%',
                                padding: '8px',
                                fontSize: '1rem',
                                border: error ? '1px solid red' : '1px solid #ccc',
                                borderRadius: '6px',
                                outline: 'none'
                            }}
                            readOnly={true}

                        />

                        {error && (
                            <div style={{ color: 'red', marginBottom: '10px' }}>
                                Please enter a value.
                            </div>
                        )}
                        <button onClick={handlePopupSubmit}>OK</button>
                        <button onClick={() => setOpen(false)}>Cancel</button>
                    </div>
                </div>
            )}
        </>
    );
}
